import useDataContext from "../../providers/DataProvider/useDataContext";
import { useEffect, useState } from "react";
import { subscribeToScroll } from "../../assets/scripts/ScrollManager";
import NavbarLink from "../NavbarLink/NavbarLink";

interface Props {
    ariaLabel?: string,
    className?: string,
    isHomePage?: boolean
    isHeader?: boolean
}

const Navbar: React.FC<Props> = ({ ariaLabel, className, isHomePage, isHeader }) => {
    const { data } = useDataContext();
    const [isScrolled, setIsScrolled] = useState(!isHomePage);

    useEffect(() => {
        if (isHomePage) {
            const unsuscribe = subscribeToScroll(setIsScrolled);
            return () => {
                unsuscribe();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <nav aria-label={ariaLabel} 
             className={className}>

            <NavbarLink navbarLink={ data.components.header.navbar.home.link }
                        navbarName={ data.components.header.navbar.home.name }
                        isHeader={ isHeader }
                        isHomePage={ isHomePage }
                        isScrolled={ isScrolled }/>

            <NavbarLink navbarLink={ data.components.header.navbar.rooms.link }
                        navbarName={ data.components.header.navbar.rooms.name }
                        isHeader={ isHeader }
                        isScrolled={ isScrolled }/>

            <NavbarLink navbarLink={ data.components.header.navbar.outside.link }
                        navbarName={ data.components.header.navbar.outside.name }
                        isHeader={ isHeader }
                        isScrolled={ isScrolled }/>

            <NavbarLink navbarLink={ data.components.header.navbar.contact.link }
                        navbarName={ data.components.header.navbar.contact.name }
                        isHeader={ isHeader }
                        isScrolled={ isScrolled }/>

            <NavbarLink navbarLink={ data.pages.bookPage.externalUrl }
                        navbarName={ data.components.header.navbar.book.name }
                        isHeader={ isHeader }
                        isScrolled={ isScrolled }
                        isExternal/>
        </nav>
    );
};

export default Navbar;
